import { storyblokEditable } from "@storyblok/react";
const SingleImageSmall = ({ blok }) => {
  return (
      <div className="singleimage-small-wrap wrap" {...storyblokEditable(blok)}>
      <img src={blok.image.filename} alt={blok.image.alt} />
      </div>
  );
};
export default SingleImageSmall;




